(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[73446],{

/***/ 25416:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ AffiliateOfferUrl; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/lib/shared/cookies.ts
var cookies = __webpack_require__(76309);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/api/index.ts + 19 modules
var api = __webpack_require__(21513);
// EXTERNAL MODULE: ./src/hooks/useDomainContext.tsx
var useDomainContext = __webpack_require__(88737);
;// CONCATENATED MODULE: ./src/components/shared/affiliateOfferUrl/mobileIcon.tsx

const MobileIcon = ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        id: "Layer_2",
        viewBox: "0 0 16 22",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            id: "Layer_1-2",
            fill: "#fff",
            d: "M2 12.25V20 2zM2 22c-.55 0-1.02-.2-1.41-.59S0 20.55 0 20V2C0 1.45.2.98.59.59S1.45 0 2 0h10c.55 0 1.02.2 1.41.59S14 1.45 14 2v2h-2V2H2v18h10v-2h2v2c0 .55-.2 1.02-.59 1.41S12.55 22 12 22zm5.71-3.5c.19-.19.29-.43.29-.71s-.1-.52-.29-.71-.43-.29-.71-.29-.52.1-.71.29-.29.43-.29.71.1.52.29.71.43.29.71.29.52-.1.71-.29m3.62-4.65L9.88 12.4c.2-.18.35-.4.46-.64s.16-.5.16-.76-.05-.52-.16-.76-.26-.45-.46-.64l1.45-1.45c.38.38.68.82.88 1.31s.3 1 .3 1.54-.1 1.05-.3 1.54-.49.93-.88 1.31m2.45 2.45-1.4-1.4c.52-.52.92-1.11 1.2-1.78s.43-1.38.43-2.13-.14-1.46-.43-2.13-.68-1.26-1.2-1.78l1.4-1.4q1.08 1.05 1.65 2.43c.57 1.38.58 1.88.58 2.88s-.19 1.96-.58 2.88-.93 1.73-1.65 2.43"
        })
    });
/* harmony default export */ var mobileIcon = (MobileIcon);

// EXTERNAL MODULE: ./src/components/shared/affiliateOfferUrl/style.module.scss
var style_module = __webpack_require__(24027);
var style_module_default = /*#__PURE__*/__webpack_require__.n(style_module);
// EXTERNAL MODULE: ./src/components/shared/offerVertical/index.tsx
var offerVertical = __webpack_require__(71466);
;// CONCATENATED MODULE: ./src/components/shared/affiliateOfferUrl/index.tsx








function AffiliateOfferUrl({ className , children , customHref , offer , target , style , zone , template ="default"  }) {
    const { 0: listId , 1: setListId  } = (0,react.useState)(null);
    const { category , locale  } = (0,useDomainContext/* useDomainContext */.w)();
    const clickToCallLabel = (0,offerVertical/* getText */.Q)(category?.config?.clickToCallLabel, locale);
    (0,react.useEffect)(()=>{
        setListId((0,cookies/* getAffiliateListId */.Hf)());
    }, [
        cookies/* getAffiliateListId */.Hf
    ]);
    const queryParams = [];
    if (listId) {
        queryParams.push(`id=${listId}`);
    }
    if (offer?.category?.id) {
        queryParams.push(`categoryId=${offer.category.id.toString()}`);
    }
    if (zone) {
        queryParams.push(`zone=${zone}`);
    }
    let innerLinkContent = children;
    if (customHref) {
        if (template === "default") {
            innerLinkContent = /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: children
            });
        } else {
            innerLinkContent = /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: (style_module_default()).clickToCallWrapper,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (style_module_default()).svgWrapper,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mobileIcon, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            className: (style_module_default()).textWrapper,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (style_module_default()).clickToCall,
                                    children: clickToCallLabel || "Click to Call"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (style_module_default()).phoneNumberClick,
                                    children: children
                                })
                            ]
                        })
                    ]
                })
            });
        }
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
        style: style,
        target: target,
        className: className ?? "",
        rel: "noreferrer",
        href: customHref ?? `/offer/${offer?.slug ?? ""}?${queryParams.join("&")}`,
        onClick: ()=>{
            if (customHref) {
                void (0,api/* callEvent */.dr)({
                    event: "Call",
                    phoneNumber: customHref?.split("tel:")[1] ?? ""
                });
            }
        },
        children: innerLinkContent
    });
}


/***/ }),

/***/ 71466:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ getText; },
/* harmony export */   "Z": function() { return /* binding */ OfferVertical; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _styles_variables_businessphonepricesVariables_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(81331);
/* harmony import */ var _styles_variables_businessphonepricesVariables_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_styles_variables_businessphonepricesVariables_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _lib_sharedUtils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75094);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(76877);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _affiliateOfferUrl__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25416);
/* harmony import */ var _hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(88737);







const getText = (text, locale)=>{
    return text?.[locale] ?? text?.["en"] ?? "";
};
function OfferVertical({ offer , zone , displayLinkAndPhoneNumber , customStyle , template ="default"  }) {
    const phoneNumber = (0,_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_2__/* .getPhoneNumber */ .ly)(offer);
    const { domain , category , locale  } = (0,_hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_4__/* .useDomainContext */ .w)();
    const callToActionTitle = getText(category?.config?.offerVerticalCallToActionTitle, locale);
    const callToActionSubTitle = getText(category?.config?.offerVerticalCallToActionSubTitle, locale);
    const buttonFallbackText = getText(category?.config?.offerVerticalButtonFallbackText, locale);
    const freeEvaluationNote = getText(category?.config?.offerVerticalFreeEvaluationNote, locale);
    const phoneNumberMessage = offer?.attributes.phoneNumberMessage ? offer?.attributes.phoneNumberMessage : offer?.hiddenAttributes.phoneNumberMessage ? offer?.hiddenAttributes.phoneNumberMessage : "";
    const outerSectionStyle = {
        "--buttonBackgroundColor": `${customStyle?.buttonBgColor ?? (_styles_variables_businessphonepricesVariables_module_scss__WEBPACK_IMPORTED_MODULE_5___default().autumnGlory)}`
    };
    const clickToCallBorder = typeof domain.config?.clickToCallBorder === "string" ? domain.config.clickToCallBorder : undefined;
    const clickToCallBtnBackground = typeof domain.config?.clickToCallBtnBackground === "string" ? domain.config.clickToCallBtnBackground : undefined;
    const clickToCallBtnForground = typeof domain.config?.clickToCallBtnForground === "string" ? domain.config.clickToCallBtnForground : undefined;
    const clickToCallBtnShadow = typeof domain.config?.clickToCallBtnShadow === "string" ? `rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0) 0px 0px 0px 0px, ${domain.config.clickToCallBtnShadow} 0px 10px 15px -3px, ${domain.config.clickToCallBtnShadow} 0px 4px 6px -4px ` : undefined;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_6___default().container)}  relative  mb-[30px] px-4 py-4   ${customStyle?.wrapperStyle ?? ""}`,
        style: outerSectionStyle,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "flex flex-col flex-wrap items-center",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: `w-40 mb-4 flex justify-center ${customStyle?.fixedHeight ? "h-20" : ""}`,
                    style: {
                        borderColor: (_styles_variables_businessphonepricesVariables_module_scss__WEBPACK_IMPORTED_MODULE_5___default().offerBorderColor)
                    },
                    children: offer.logo && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: offer.logo.fullPath,
                        alt: offer.title
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "w-full",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "w-full",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                    className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_6___default().title),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        style: {
                                            fontSize: "24px",
                                            fontWeight: "700",
                                            lineHeight: 1.2
                                        },
                                        dangerouslySetInnerHTML: {
                                            __html: phoneNumberMessage || callToActionTitle || "Call Now & Discuss Options!"
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_6___default().secondTitle),
                                    children: callToActionSubTitle || "Review offers and coverage eligibility instantly."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "order-3 flex flex-col mt-2 w-auto",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_affiliateOfferUrl__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                    zone: zone,
                                    template: template,
                                    className: `${!displayLinkAndPhoneNumber ? (_style_module_scss__WEBPACK_IMPORTED_MODULE_6___default().link) : ""} ${(_style_module_scss__WEBPACK_IMPORTED_MODULE_6___default().linkPageBuilderStyle)} ${(_style_module_scss__WEBPACK_IMPORTED_MODULE_6___default().btnStyle)} flex justify-center rounded-5 text-center px-[10px] py-[10px] text-[15px]`,
                                    offer: offer,
                                    customHref: phoneNumber ? `tel:${phoneNumber ?? ""}` : undefined,
                                    target: "_blank",
                                    style: {
                                        borderRadius: "12px",
                                        border: clickToCallBorder,
                                        background: clickToCallBtnBackground,
                                        color: clickToCallBtnForground,
                                        boxShadow: clickToCallBtnShadow
                                    },
                                    children: (0,_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_2__/* .formatPhoneNumber */ .un)(phoneNumber) || buttonFallbackText || "Let's Go"
                                }),
                                displayLinkAndPhoneNumber && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_affiliateOfferUrl__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                    zone: zone,
                                    className: `text-left lg:text-center py-3 rounded-lg ${(_style_module_scss__WEBPACK_IMPORTED_MODULE_6___default().letGoStyle)}`,
                                    offer: offer,
                                    target: "_blank",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        children: buttonFallbackText || "Let's Go"
                                    })
                                })
                            ]
                        }),
                        (0,_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_2__/* .formatPhoneNumber */ .un)(phoneNumber) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            style: {
                                fontSize: "12px",
                                color: "#666",
                                textAlign: "center",
                                marginTop: "15px"
                            },
                            children: freeEvaluationNote || "Free Evaluation • No Obligation"
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {})
                    ]
                })
            ]
        })
    });
}


/***/ }),

/***/ 73446:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ WeStand; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/svg/rocketIcon.tsx


function RocketIcon({ className  }) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "32",
        height: "44",
        viewBox: "0 0 32 44",
        className: className ?? "",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#FE895C",
                d: "M26.075 4.974A23.5 23.5 0 0117.59.9l-.858-.654a1.21 1.21 0 00-1.466 0l-.856.65A23.486 23.486 0 015.928 4.97c-.546.137-.93.633-.928 1.201v7.647a14.632 14.632 0 005.75 11.612l4.517 3.421a1.21 1.21 0 001.466 0l4.523-3.421A14.631 14.631 0 0027 13.818V6.171c0-.566-.381-1.06-.925-1.197z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#FE895C",
                d: "M10.057 7.842h11.886C27.497 7.842 32 12.344 32 17.899H0C0 12.344 4.503 7.842 10.057 7.842z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ellipse", {
                cx: "16",
                cy: "13.007",
                fill: "#FFF",
                rx: "4",
                ry: "4.023"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#FE895C",
                d: "M12.028 24.07h7.944A5.028 5.028 0 0125 29.098H7a5.028 5.028 0 015.028-5.028zM16 44s4-6.646 4-8.868c0-2.222-1.79-4.023-4-4.023s-4 1.801-4 4.023C12 37.354 16 44 16 44z"
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/styles/variables/vpnpricecomparisonVariables.module.scss
var vpnpricecomparisonVariables_module = __webpack_require__(75735);
var vpnpricecomparisonVariables_module_default = /*#__PURE__*/__webpack_require__.n(vpnpricecomparisonVariables_module);
// EXTERNAL MODULE: ./src/lib/sharedUtils.ts
var sharedUtils = __webpack_require__(75094);
// EXTERNAL MODULE: ./src/hooks/useDomainContext.tsx
var useDomainContext = __webpack_require__(88737);
// EXTERNAL MODULE: ./src/components/shared/affiliateOfferUrl/index.tsx + 1 modules
var affiliateOfferUrl = __webpack_require__(25416);
// EXTERNAL MODULE: ./src/lib/shared/config.ts
var config = __webpack_require__(98218);
;// CONCATENATED MODULE: ./src/components/vpnpricecomparison/weStand/index.tsx








function WeStand() {
    const { domain  } = (0,useDomainContext/* useDomainContext */.w)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        style: {
            backgroundColor: (0,sharedUtils/* hexToRGBA */.E9)((vpnpricecomparisonVariables_module_default()).melon, 0.05),
            color: (vpnpricecomparisonVariables_module_default()).navy
        },
        className: "text-center md:max-w-3xl lg:max-w-7xl md:mx-auto pt-12 lg:pt-16 pb-16 lg:pb-20 px-12 mb-11",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RocketIcon, {
                className: "mx-auto"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: "text-xl font-bold mt-4",
                children: "We Stand for Internet Freedom & Privacy"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: "mt-3 font-light lg:mx-auto",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "We've diligently partnered with the world's leading VPN service providers, securing exclusive deals on their monthly and yearly packages. Out of the 12 companies we've collaborated with, CyberGhost stands out as offering the highest overall value."
                    }),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(affiliateOfferUrl/* default */.Z, {
                        zone: config/* affiliateOfferZones.HOME_PAGE */.ZR.HOME_PAGE,
                        offer: domain?.defaultOffers[0],
                        className: "text-vpn-comparison-melon",
                        target: "_blank",
                        children: "CyberGhost"
                    }),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "Offers the Highest Value Overall."
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 24027:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"clickToCallWrapper":"style_clickToCallWrapper__VwAdQ","textWrapper":"style_textWrapper__4UGtd","svgWrapper":"style_svgWrapper__hIySB","clickToCall":"style_clickToCall__9Mqb6","phoneNumberClick":"style_phoneNumberClick__xFVNS"};

/***/ }),

/***/ 76877:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__wOf18","title":"style_title__cWvij","linkPageBuilderStyle":"style_linkPageBuilderStyle__CqdI2","letGoStyle":"style_letGoStyle__5KJJo","link":"style_link__LGb3m","secondTitle":"style_secondTitle__6rLsc","btnStyle":"style_btnStyle__6X7g_"};

/***/ }),

/***/ 81331:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"goGoGreen":"#008a7b","green":"#5bc1a4","bankVault":"#747474","autumnGlory":"#3ea636","offerBorderColor":"#e4e7eb"};

/***/ }),

/***/ 75735:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"melon":"#fe895c","darkSeaGreen":"#0e7d3f","marigold":"#ffcb03","fadedRed":"#cd2f32","dodgerBlue":"#4f85ff","pinkishGrey":"#bfbfbf","sea":"#329eaa","softBlue":"#6b67e9","slightlyBlack":"#161616","tealGreen":"#83b855","greyish":"#b3b3b3","paleGrey":"#f8f9fa","navy":"#011d41","pagePaddingX":"1rem"};

/***/ })

}]);